export const ROUTES = {
    auth: 'Auth',
    login: 'AuthLogin',
    authReset: 'AuthReset',
    authSetNewPassword: 'AuthSetNewPassword',
    register: 'Register',
    reporting: 'Reporting',
    reviewAccount: 'ReviewAccount',
    referral: 'Referral',
    withdrawal: 'Withdrawal',
    rates: 'Rates',
    withdrawalPlatform: 'WithdrawalPlatform',
    detailWithdrawalPlatform: 'DetailWithdrawalPlatform',
    verification: 'Verification',
    profile: 'Profile',
    accountSetting: 'AccountSetting',
    password: 'Password',
    twoFactorAuth: 'TwoFactorAuth',
    accountDisabled: 'AccountDisabled',
}
